<div class="command-palette" mat-dialog-content>
  <div class="filter-row">
    @if (showChangeDealer()) {
      <button class="back-button" data-ignore-lint type="button" (click)="backToCommands()">
        <mat-icon class="filter-icon" [svgIcon]="IconNames.ice_chevron_left" />
      </button>
    } @else {
      <mat-icon class="filter-icon" [svgIcon]="IconNames.ice_search" />
    }
    <input
      #filterInput
      class="filter-input"
      data-testid="command-palette-input"
      type="text"
      [placeholder]="showChangeDealer() ? 'Søk etter dealer...' : 'Skriv en kommando...'"
      [value]="filterText()"
      (input)="onFilterChange(filterInput.value)"
      (keydown)="onKeydown($event)"
    />
  </div>

  @if (showChangeDealer()) {
    <ul class="command-list">
      @for (dealer of filteredDealers(); track dealer.dealerId; let i = $index) {
        <li
          class="command-item"
          data-ignore-lint
          [class.active]="i === activeIndex()"
          (click)="selectDealer(dealer)"
          (mouseenter)="activeIndex.set(i)"
        >
          <span class="command-label">{{ dealer.displayName }}</span>
          @if (isActiveDealer(dealer)) {
            <mat-icon class="command-hint-icon" [svgIcon]="IconNames.ice_checkmark" />
          }
        </li>
      } @empty {
        <li class="command-empty">Fant ingen dealer</li>
      }
    </ul>
  } @else {
    <ul class="command-list">
      @for (command of filteredCommands(); track command.id; let i = $index) {
        <li
          class="command-item"
          data-ignore-lint
          [class.active]="i === activeIndex()"
          (click)="runCommand(command)"
          (mouseenter)="activeIndex.set(i)"
        >
          <mat-icon class="command-icon" [svgIcon]="command.icon" />
          <span class="command-label">{{ command.label }}</span>
          <span class="command-hint">Enter</span>
        </li>
      } @empty {
        <li class="command-empty">No matching commands</li>
      }
    </ul>
  }
</div>
